module.exports = __webpack_public_path__ + "img/successful.20c91e9d.svg";